// extracted by mini-css-extract-plugin
module.exports = {"conferences":"conferences_conferences__3RuJa","videos":"conferences_videos__2ZubW","grid":"conferences_grid__1mdED"};